import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_CREATE_CAMPAIGN_URL, KNOWLEDGE_BASE_CREATE_CAMPAIGN_URL } from '../../../utils/urls';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateCampaignModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('CreateCampaignModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createCampaign.heading"
    }),
    illustrationName: "successful-send",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.createCampaign.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createCampaign.li1"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createCampaign.li2"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createCampaign.li3"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createCampaign.li4"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createCampaign.li5"
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('create campaign article'),
      url: KNOWLEDGE_BASE_CREATE_CAMPAIGN_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_CREATE_CAMPAIGN_URL,
      onClick: () => trackLink('create campaign lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
CreateCampaignModal.propTypes = {
  onClose: PropTypes.func
};
export default CreateCampaignModal;